import React from "react";
import "./ElementTile.css";

export default function ElementTile({ number, symbol, name, mass, onClick, isSelected }) {
  return (
    <div
      className={`element-tile${isSelected ? " selected" : ""}`}
      onClick={onClick}
      tabIndex={0}
      title={name}
    >
      <div className="atomic-number">{number}</div>
      <div className="element-symbol">{symbol}</div>
      <div className="element-name">{name}</div>
      <div className="atomic-mass">{mass}</div>
    </div>
  );
}
